import { render, staticRenderFns } from "./ImageAigcLayout.vue?vue&type=template&id=370ac4b6&scoped=true&"
import script from "./ImageAigcLayout.vue?vue&type=script&lang=js&"
export * from "./ImageAigcLayout.vue?vue&type=script&lang=js&"
import style0 from "./ImageAigcLayout.vue?vue&type=style&index=0&id=370ac4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ac4b6",
  null
  
)

export default component.exports